export function getOffsetTop(element: HTMLElement | null) {
  if (element === null) return 0;
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop - element.scrollTop + element.clientTop;
    element = element.offsetParent as HTMLElement;
  }
  return offsetTop;
}
